import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Link from "@insightfulscience/atomic-react/Link";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import { useLocale } from "@insightfulscience/smart-react/i18";
import routes from "../routes";

const Error500 = () => {
	const [t] = useLocale("app-error");

	return (
		<>
			<PageTitle title={t("500.META_TITLE")} />
			<Heading Tag="h1" level={1} size="xl" center className="mb-6 text-color-1">
				{t("500.TITLE")}
			</Heading>
			<Paragraph size="s" center className="">
				{t("500.DESCRIPTION")}
				<br />
				<br />
				{t("500.PARAGRAPH_1")}
				<Link href={routes.external.help} size="s">
					{t("500.CONTACT_US")}
				</Link>{" "}
				{t("500.PARAGRAPH_2")}
			</Paragraph>
		</>
	);
};

export default Error500;
